<template>
    <component :text='text' :icon_name="icon_name" :is="type" />
</template>

<script>
import iconRight from './card_bg_icon_right';
import iconTop from './card_bg_icon_top';

export default {
    components: {
        right: iconRight,
        top  : iconTop
    },
    props: {
        type: {
            type   : String,
            default: 'right'
        },
        text: {
            type: String
        },
        icon_name: {
            type: String
        }
    },
};
</script>

<style>

</style>
